import { FC } from "react";
import styled from "styled-components";

import ScrollableTable from "@/components/ScrollableTable";
import {
  ExtraLargeTh,
  MediumTh,
  Table,
  TableContent,
  Th,
} from "@/components/Table";
import { ReleaseResource } from "@/types/resources";
import DistributionScheduleDetailsTableRow from "./DistributionScheduleDetailsTableRow";
import Text from "@/components/Text";

const StyledTable = styled(Table)`
  th,
  td {
    padding: 16px 12px;
    font-size: 11px;
    vertical-align: top;
    &:nth-child(1) {
      width: 128px;
      min-width: 128px;
      padding-left: 24px;
    }
    &:nth-child(2) {
      min-width: 116px;
    }
    &:last-child {
      padding-right: 24px;
    }
  }
`;

interface Props {
  release: ReleaseResource;
}

const DistributionScheduleDetailsTable: FC<Props> = ({ release }) => {
  return (
    <ScrollableTable>
      <StyledTable>
        <thead>
          <tr>
            <Th>Project ID</Th>
            <Th>Thumbnail</Th>
            <ExtraLargeTh>Video Title</ExtraLargeTh>
            <Th>Fresh ID</Th>
            <Th>Network & Channel</Th>
            <Th>Compilation Type</Th>
            <Th>Scheduled Date</Th>
            <MediumTh>Director</MediumTh>
            <MediumTh>Editor</MediumTh>
            <MediumTh>Publisher</MediumTh>
            <MediumTh>Archivist</MediumTh>
            <Th>Link</Th>
            <Th>Part In</Th>
            <Th>Compilation Group</Th>
            <Th>Recipe Status</Th>
            <ExtraLargeTh>Description</ExtraLargeTh>
            <ExtraLargeTh>
              Note{" "}
              <Text as="span" $color="gray" $type="smallHeadline">
                (Internal Information)
              </Text>
            </ExtraLargeTh>
          </tr>
        </thead>
        <tbody>
          <TableContent isLoading={false} isError={false} hasData={true}>
            <DistributionScheduleDetailsTableRow release={release} />
          </TableContent>
        </tbody>
      </StyledTable>
    </ScrollableTable>
  );
};

export default DistributionScheduleDetailsTable;
